var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',{staticClass:"pill-wrap"},[_c('span',{staticClass:"text-center text-bold pill capitalize",class:{ 'green-pill': _vm.params.value == 'GENERIC' }},[_vm._v(" "+_vm._s(_vm.normalizeValues(_vm.params.value))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }